import { useState } from 'react';
import { Modal, Button, Table, Spinner, Badge, Card, Alert } from 'react-bootstrap';
import axios from '../../../../apis/Api';
import { toast } from 'react-toastify';

const RepaymentConfirmationModal = ({ show, handleClose, data, onSuccess }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const submitPaymentData = async () => {
        if (!data) return;

        try {
            setIsSubmitting(true);

            const response = await axios.post(
                '/api/ManualCallback/Lender/Creditbook/JazzCash/failed',
                {
                    lenderFinancingRepaymentId: data.lenrderFinancingRepaymentId,
                    amount: data.amount,
                    dateCreated: data.paymentDate,
                    tid: data.tid,
                }
            );

            if (response.data?.isSuccess) {
                toast.success('Payment submitted successfully');
                onSuccess(); // 🔹 reset main form
            } else {
                toast.error(response.data?.message);
            }
        } catch {
            toast.error('Submission error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal show={show} size="lg" backdrop="static">
            <Modal.Header>
                <Modal.Title>Confirm Repayment</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {data && (
                    <>
                        <Table responsive>
                            <tbody>
                                <tr>
                                    <th>Loan ID</th>
                                    <td>{data.loanDisplayId}</td>
                                    <th>TID</th>
                                    <td>
                                        <Badge bg="warning" text="dark">
                                            {data.tid}
                                        </Badge>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Amount</th>
                                    <td>Rs. {Number(data.amount).toLocaleString()}</td>
                                    <th>Date</th>
                                    <td>{new Date(data.paymentDate).toLocaleDateString()}</td>
                                </tr>
                                <tr>
                                    <th>Viz Shop</th>
                                    <td>{data.vizShopCode}</td>
                                    <th>Invoice</th>
                                    <td>{data.invoice}</td>
                                </tr>
                            </tbody>
                        </Table>

                        <div className="alert alert-light" role="alert">
                            <i className="fas fa-info-circle"></i>
                            <span className='pl-2'>
                                Please verify the Transaction ID (TID)
                                against the bank statement before confirming the payment.
                                This action cannot be undone.
                            </span>
                        </div>
                    </>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="outline-secondary"
                    onClick={handleClose}
                    disabled={isSubmitting}
                >
                    Cancel
                </Button>

                <Button
                    variant="primary"
                    onClick={submitPaymentData}
                    disabled={isSubmitting}
                >
                    {isSubmitting ? (
                        <>
                            <Spinner size="sm" className="me-2" />
                            Submitting...
                        </>
                    ) : (
                        'Confirm Payment'
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RepaymentConfirmationModal;
